module.exports = {
  label: {
    vendor: 'GoMax',
    appName: 'Cloud'
  },
  color: {
    theme: '#999'
  }
}



// WEBPACK FOOTER //
// ./src/sass/_variables/gomax.js